<div class="card-item">
  <address class="card-content">
    <div class="personal-info">
      <div *ngIf="topline" class="copy-s topline">{{ topline }}</div>
      <div class="name h4 font-family-title">{{ fullname }}</div>
      <div class="position copy-m font-family-text">
        {{ position }}
      </div>
    </div>
    <div class="contact-info" *ngIf="email || phone">
      <div class="contact-info-item font-family-text contact-mail" *ngIf="email">
        <div class="info-label copy-s">{{ 'EMAIL' | translate }}:</div>
        <div class="info-value">
          <a class="btn btn-text" href="mailto:{{ email }}">{{ email }}</a>
        </div>
      </div>
      <div class="contact-info-item font-family-text contact-phone" *ngIf="phone">
        <div class="info-label copy-s">{{ 'PHONE' | translate }}:</div>
        <div class="info-value button-label">
          <a class="btn btn-text" href="tel:{{ phone }}">{{ phone }}</a>
        </div>
      </div>
    </div>
  </address>
  <div *ngIf="!hideMedia" class="card-image-wrapper">
    <div class="card-image-wrapper-inner">
      <figure *ngIf="media">
        <mb-image class="absolute-positioned" [media]="media" (imageError)="media = undefined"></mb-image>
      </figure>
      <div class="picture-replacement font-family-title" *ngIf="!media">
        <span class="initials">{{ initials }}</span>
      </div>
    </div>
  </div>
</div>
